import React from 'react'
import { Tab, Row, Nav } from 'react-bootstrap'
import { useRouteMatch, Switch, Route } from 'react-router'
import GsiApplication from './GsiApplications'
import GsiReturn from './GsiReturn'
import AddChequeDetails from '../AddChequeDetails'

const Gsi = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route path={`${path}/`} exact>
        <Tab.Container id="left-tabs-example" defaultActiveKey="Gsi">
          <Row className="tab-page-layout">
            <Nav variant="pills" className="flex-row">
              <Nav.Item className="custom-nav-item">
                <Nav.Link eventKey="Gsi">GSI Applications</Nav.Link>
              </Nav.Item>
              <Nav.Item className="custom-nav-item">
                <Nav.Link eventKey="Gsi-return">GSI Return</Nav.Link>
              </Nav.Item>
            </Nav>
          </Row>
          <Row className="page-tiles-layout">
            <Tab.Content>
              <Tab.Pane eventKey="Gsi">
                <GsiApplication />
              </Tab.Pane>
              <Tab.Pane eventKey="Gsi-return">
                <GsiReturn />
              </Tab.Pane>
            </Tab.Content>
          </Row>
        </Tab.Container>
      </Route>
      <Route
        path={`${path}/add/:id`}
        render={(props) => <AddChequeDetails scheme={'GSI'} {...props} />}
      />
    </Switch>
  )
}

export default Gsi
